<template>
  <div class="login">
    <div class="blur"></div>

    <div class="container">
      <h3 class="title">
        养长福健康中心管理系统
        <br />
        门店后台管理系统
      </h3>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login_form" @keyup.enter.native="submitForm('ruleForm')">
        <el-form-item prop="account">
          <el-input v-model="ruleForm.account" placeholder="请输入账号">
            <img slot="prefix" src="../assets/img/login/user.png" />
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="pwd">
          <el-input v-model="ruleForm.password" show-password placeholder="请输入密码">
            <img slot="prefix" src="../assets/img/login/pass.png" />
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="more">
            <!-- <div @click="goToUrl(1)">注册</div> -->
            <div></div>
            <div @click="goToUrl(2)">忘记密码</div>
          </div>
          <el-button type="primary" :loading="btnLoading" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <footers class="login_footers" /> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        account: "",
        password: "",
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    }
  },
  created() {
    this.$store.dispatch("logout")
  },
  mounted() {
    localStorage.clear()
  },
  methods: {
    goToUrl(value) {
      if (value == 1) {
        this.$router.push({ path: "/register" })
      } else {
        this.$router.push({ path: "/forgotPassword" })
      }
    },
    // 递归方法用于获取所有最深层子元素的menuPath
    getDeepestMenuPath(arr) {
      let paths = [] // 用于存储所有找到的menuPath
      // 递归函数
      function recurse(children, depth) {
        // 遍历当前层级的children
        for (let item of children) {
          // 如果当前item没有children，则认为它是叶子节点，记录其menuPath
          if (!item.children || item.children.length === 0) {
            paths.push(item.menuPath)
          } else {
            // 如果有children，则递归进入下一层
            recurse(item.children, depth + 1)
          }
        }
      }
      // 开始递归
      recurse(arr, 0)
      return paths // 返回所有最深层menuPath组成的数组
    },
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.$axios
            .post(this.$api.login, {
              userAccount: this.ruleForm.account,
              userPassword: this.ruleForm.password,
              bizSys: this.$bizSys,
            })
            .then(res => {
              const menus = res.result.sysMenuVoList
              let paths = this.getDeepestMenuPath(menus)
              this.$store.commit("setToken", res.result.token)
              this.$store.commit("setMenuList", menus)
              this.$store.commit("setUserInfo", res.result.loginUser)
              this.$message.success("登录成功")
              setTimeout(() => {
                if (menus.length > 0) {
                  let path = paths[0]
                  this.$router.replace({ path })
                } else {
                  this.$router.replace("/404")
                }
              }, 500)
              this.btnLoading = false
            })
            .catch(err => {
              this.btnLoading = false
              this.$message.error(err.desc)
            })
        } else {
          this.btnLoading = false
          this.$message.error("登录失败")
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .blur {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(../assets/img/login/login.png) no-repeat;
    background-size: cover;
    background-position: 100% 30%;
    // filter: blur(2px);
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px;
    border-radius: 6px;
    background-color: #fff;

    .title {
      color: #1a1a1a;
      font-size: 26px;
      text-align: center;
      font-weight: 500;
      margin-bottom: 60px;
    }

    .login_form {
      width: 400px;

      ::v-deep .el-input__inner {
        width: 100%;
        height: 50px;
        font-size: 16px;
        padding-left: 46px;
        border: 1px solid #dcdfe6;
        border-radius: 10px;
        background-color: #fff;

        &:hover {
          border-color: #c0c4cc;
        }

        &:focus {
          border-color: #069bbc;
        }
      }

      ::v-deep .el-input__prefix {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 46px;

        img {
          width: 16px;
          height: 18px;
        }
      }

      .el-form-item:last-child {
        margin-bottom: 0;
      }

      .pwd {
        margin-bottom: 12px;
      }

      .more {
        display: flex;
        justify-content: space-between;
        color: #707070;

        div {
          cursor: pointer;
        }
      }

      .el-button {
        width: 100%;
        height: 50px;
        font-size: 16px;
        border-radius: 10px;
      }
    }
  }
}
</style>
